import { NgModule } from '@angular/core';
import { Route } from '@angular/router';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [],
})
export class UnsubscribeModule {
    static defineRoute(path: string): Route {
        return {
            path,
            loadChildren: () =>
                import('app/unsubscribe/unsubscribe.lazy.module').then((m) => m.UnsubscribeLazyLoadedModule),
        };
    }
}
